import React, { useEffect } from 'react';

const CherryCalculator = () => {
  useEffect(() => {
    const originalIOObserve = IntersectionObserver.prototype.observe;
    IntersectionObserver.prototype.observe = function (target) {
      if (!(target instanceof Element)) return;
      return originalIOObserve.call(this, target);
    };

    const originalROObserve = ResizeObserver.prototype.observe;
    ResizeObserver.prototype.observe = function (target, options) {
      if (!(target instanceof Element)) return;
      return originalROObserve.call(this, target, options);
    };

    const isCherryWidgetError = (event) => {
      const msg = event.message || '';
      if (
        msg === 'Script error.' ||
        msg.includes('Script error') ||
        msg.includes('ResizeObserver') ||
        msg.includes('IntersectionObserver') ||
        msg.includes('withcherry')
      ) return true;
      if (event.filename && event.filename.includes('withcherry.com')) return true;
      if (event.error && event.error.stack && event.error.stack.includes('withcherry.com')) return true;
      return false;
    };

    const handleGlobalError = (event) => {
      if (isCherryWidgetError(event)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return true;
      }
    };
    window.addEventListener('error', handleGlobalError, true);

    const handleUnhandledRejection = (event) => {
      const reason = event.reason;
      if (
        reason &&
        ((reason.stack && reason.stack.includes('withcherry.com')) ||
         reason.message === 'Script error.' ||
         (typeof reason === 'string' && reason.includes('withcherry')))
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    };
    window.addEventListener('unhandledrejection', handleUnhandledRejection, true);

    const originalConsoleError = console.error;
    console.error = function (...args) {
      const msg = typeof args[0] === 'string' ? args[0] : '';
      const fullMsg = args.map(a => String(a)).join(' ');
      if (
        msg.includes('Script error') ||
        msg.includes('ResizeObserver') ||
        msg.includes('IntersectionObserver') ||
        fullMsg.includes('withcherry.com')
      ) return;
      originalConsoleError.apply(console, args);
    };

    const fontLinkId = 'cherry-widget-fonts';
    if (!document.getElementById(fontLinkId)) {
      const link = document.createElement('link');
      link.id = fontLinkId;
      link.href = 'https://fonts.googleapis.com/css2?family=Montserrat:wght@200..900&display=swap';
      link.rel = 'stylesheet';
      document.head.appendChild(link);
    }

    const initWidget = () => {
      try {
        // Always ensure the script tag is present (idempotent — won't add twice)
        (function (w, d, s, o, f, js, fjs) {
          w[o] = w[o] || function () {
            (w[o].q = w[o].q || []).push(arguments);
          };
          js = d.getElementById(o);
          if (!js) {
            js = d.createElement(s);
            fjs = d.getElementsByTagName(s)[0];
            js.id = o;
            js.src = f;
            js.async = 1;
            js.crossOrigin = 'anonymous';
            js.onerror = () => {};
            if (fjs && fjs.parentNode) {
              fjs.parentNode.insertBefore(js, fjs);
            } else {
              d.head.appendChild(js);
            }
          }
        })(window, document, 'script', '_hw', 'https://files.withcherry.com/widgets/widget.js');

        const cherryConfig = window.__cherryInitConfig || {
          debug: false,
          variables: {
            slug: 'life-and-wellness-center',
            name: 'Life And Wellness Center',
            images: [26],
            customLogo: '',
            defaultPurchaseAmount: 750,
            customImage: '',
            imageCategory: 'medspa',
            language: 'en',
            testMode: false
          },
          styles: {
            primaryColor: '#5a8a73',
            secondaryColor: '#5a8a7310',
            fontFamily: 'Montserrat',
            headerFontFamily: 'Montserrat'
          }
        };
        window.__cherryInitConfig = cherryConfig;
        window.__cherryInitialized = true;

        const calcDiv = document.getElementById('calculator');
        if (calcDiv && window._hw) {
          try {
            window._hw('init', cherryConfig, ['calculator']);
          } catch (e) { /* widget may already be mounted */ }
        }
      } catch (e) { /* non-critical */ }
    };

    // Kick off the first init quickly
    const initTimer = setTimeout(initWidget, 200);

    // Polling retry: until the calculator div has visible content,
    // keep nudging the widget to render. Stops after ~10 seconds.
    let attempts = 0;
    const MAX_ATTEMPTS = 16;
    const retryInterval = setInterval(() => {
      attempts += 1;
      const calcDiv = document.getElementById('calculator');
      if (!calcDiv) return;
      // Consider rendered if the div has child elements (widget injected DOM)
      if (calcDiv.children && calcDiv.children.length > 0) {
        clearInterval(retryInterval);
        return;
      }
      if (attempts >= MAX_ATTEMPTS) {
        clearInterval(retryInterval);
        return;
      }
      initWidget();
    }, 600);

    return () => {
      clearTimeout(initTimer);
      clearInterval(retryInterval);
      window.removeEventListener('error', handleGlobalError, true);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection, true);
      console.error = originalConsoleError;
      IntersectionObserver.prototype.observe = originalIOObserve;
      ResizeObserver.prototype.observe = originalROObserve;
    };
  }, []);

  return (
    <div className="cherry-calculator-mount">
      <div id="calculator" style={{ minHeight: '320px' }}></div>
    </div>
  );
};

export default CherryCalculator;
